import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, isRef as _isRef, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, renderList as _renderList, createTextVNode as _createTextVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/img/icon/close.png'
import _imports_1 from '../../assets/img/icon/add.png'
import _imports_2 from '../../assets/img/icon/iconF.png'


const _withScopeId = n => (_pushScopeId("data-v-09799ed4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "submit-box" }
const _hoisted_2 = { class: "content-box" }
const _hoisted_3 = {
  key: 0,
  class: "upload-box"
}
const _hoisted_4 = {
  key: 1,
  class: "book-box"
}
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "box-tmp" }
const _hoisted_7 = { class: "book-name" }
const _hoisted_8 = { class: "book-info" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: ""
}, null, -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "添加书籍", -1))
const _hoisted_11 = [
  _hoisted_9,
  _hoisted_10
]
const _hoisted_12 = { class: "foot-box" }
const _hoisted_13 = ["onClick"]
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  alt: ""
}, null, -1))
const _hoisted_15 = {
  key: 2,
  class: "type-box"
}
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "将动态发布于", -1))
const _hoisted_17 = /*#__PURE__*/_createTextVNode("读书会")
const _hoisted_18 = /*#__PURE__*/_createTextVNode(" 跑团")

import { ref, onMounted, reactive, watch } from 'vue';
import { usNewPosting } from '@/api/request';
import { Toast } from 'vant';
import http from '@/api/index';
import BookList from '@/components/release/book.vue';
import { useRouter } from 'vue-router';
import { ElMessage } from 'element-plus';
interface EmitsType {
  (e: 'cancel'): void;
  (e: 'update:confirm'): void;
}

export default /*#__PURE__*/_defineComponent({
  props: {
  show: {
    type: Boolean,
    default: false
  },
  // 1.普通发帖，2.读书发帖 3.跑步发帖
  type: {
    type: String,
    default: '1'
  },
  contentFlag: {
    type: String,
    default: ''
  },
  actInfo: {
    type: Object,
    // eslint-disable-next-line vue/require-valid-default-prop
    default: {}
  }
},
  emits: ["cancel", "update:confirm"],
  setup(__props, { emit }: { emit: ({
  (e: 'cancel'): void;
  (e: 'update:confirm'): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props

const router = useRouter();




const showBook = ref(false);
const showRun = ref(false);
const showD = ref(false);
const scText = ref('');
const topicType = ref('');
const scType = ref('2');
const circleTopicList = reactive<any>([]);
const fileList = reactive<any>([]);
const scPicUrl = ref<string[]>([]);

const bookInfo = ref({
  bookImg: '',
  bookName: '',
  id: '',
  readPersonNum: ''
});

watch(
  () => props.show,
  (val) => {
    showD.value = val;
  }
);
watch(
  () => props.contentFlag,
  (val) => {
    console.log(props.contentFlag, val, 'props.content');
    if (props.contentFlag) {
      scText.value = props.contentFlag;
    }
  }
);
watch(
  () => props.type,
  (val) => {
    if (val === '3') {
      showRun.value = true;
    }
  }
);

onMounted(() => {
  getSelTopic();
});

// 读书专属打卡
const submitRead = async() => {
  const extContent = {
    bookName: bookInfo.value.bookName,
    bookUrl: bookInfo.value.bookImg,
    readPersonNum: bookInfo.value.readPersonNum
  };

  let params = {};
  if (props.actInfo) {
    params = {
      scText: scText.value,
      scPicUrl: scPicUrl.value.join(','),
      mappingId: bookInfo.value.id,
      scType: scType.value,
      subType: 1,
      extContent: extContent,
      scSource: '1',
      ...props.actInfo
    };
  } else {
    params = {
      scText: scText.value,
      scPicUrl: scPicUrl.value.join(','),
      mappingId: bookInfo.value.id,
      scType: scType.value,
      subType: 1,
      extContent: extContent
    };
  }
  console.log(params);
  // return;

  const res = await usNewPosting.posting(params);
  if (res.code === '00') {
    Toast('发帖成功');
    showD.value = false;
    // router.push({
    //   name: 'mine'
    // });
    emit('cancel');
  }
};

const submitAll = () => {
  if (scText.value.length < 9) {
    ElMessage({
      message: '最少输入十个字哦',
      type: 'warning'
    });
    return;
  }
  if (props.type === '2') {
    submitRead();
  } else {
    submit();
  }
};

const afterRead = (file: any) => {
  const formData = new FormData();
  const ext = file.content
    .split(',')[0]
    .split(':')[1]
    .split(';')[0]
    .split('/')[1];
  formData.append('file', `${ext},${file.content.split(',')[1]}`);
  http.post('/uploadFile', formData).then((res) => {
    fileList.push({
      url: `https://yzims.oss-cn-shenzhen.aliyuncs.com/${res.body}`
    });
    scPicUrl.value.push(res.body);
  });
};
const deleteImg = (file: any, detail: any) => {
  scPicUrl.value.splice(detail.index, 1);
  fileList.splice(detail.index, 1);
};

const addContent = (content: string, topicTypeName: string) => {
  scText.value += `#${content}#`;
  topicType.value = topicTypeName;
};
// 发帖
const submit = async() => {
  const params = {
    scText: scText.value,
    scPicUrl: scPicUrl.value.join(','),
    scType: scType.value
  };
  const res = await usNewPosting.posting(params);
  if (res.code === '00') {
    Toast('发帖成功');
    showD.value = false;
    emit('cancel');
    router.push({
      name: 'mine'
    });
  }
};

// 获取话题
const getSelTopic = async() => {
  const res = await usNewPosting.selCircleTopic();
  circleTopicList.values = res.body;
};

const handleClose = () => {
  // location.reload();
  showD.value = false;
  emit('cancel');
};

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_van_uploader = _resolveComponent("van-uploader")!
  const _component_van_radio = _resolveComponent("van-radio")!
  const _component_van_radio_group = _resolveComponent("van-radio-group")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_dialog, {
      modelValue: showD.value,
      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((showD).value = $event)),
      "show-close": false,
      width: "400px",
      "before-close": handleClose
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", { class: "head-box" }, [
          _createElementVNode("img", {
            class: "close",
            onClick: handleClose,
            src: _imports_0,
            alt: ""
          }),
          _createElementVNode("button", { onClick: submitAll }, "发布")
        ]),
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_el_input, {
            modelValue: scText.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((scText).value = $event)),
            rows: 6,
            type: "textarea",
            placeholder: ""
          }, null, 8, ["modelValue"]),
          (props.type === '1')
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createVNode(_component_van_uploader, {
                  "before-delete": deleteImg,
                  "after-read": afterRead,
                  modelValue: _unref(fileList),
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_isRef(fileList) ? (fileList).value = $event : fileList = $event)),
                  multiple: ""
                }, null, 8, ["modelValue"])
              ]))
            : _createCommentVNode("", true),
          (props.type === '2')
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                (bookInfo.value.bookName)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createElementVNode("img", {
                        class: "book-img",
                        src: 
                'https://yzims.oss-cn-shenzhen.aliyuncs.com/' + bookInfo.value.bookImg
              ,
                        alt: ""
                      }, null, 8, _hoisted_5),
                      _createElementVNode("div", _hoisted_6, [
                        _createElementVNode("p", _hoisted_7, _toDisplayString(bookInfo.value.bookName), 1),
                        _createElementVNode("p", _hoisted_8, " 累计发布读书笔记" + _toDisplayString(bookInfo.value.readPersonNum) + "篇 ", 1),
                        _createElementVNode("p", {
                          class: "change",
                          onClick: _cache[2] || (_cache[2] = ($event: any) => (showBook.value = true))
                        }, "更换")
                      ])
                    ], 64))
                  : (_openBlock(), _createElementBlock("div", {
                      key: 1,
                      class: "addBook",
                      onClick: _cache[3] || (_cache[3] = ($event: any) => (showBook.value = true))
                    }, _hoisted_11))
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("ul", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(circleTopicList).values, (item, index) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: index,
                  onClick: ($event: any) => (addContent(item.topicName, item.topicType))
                }, [
                  _hoisted_14,
                  _createElementVNode("span", null, _toDisplayString(item.topicName), 1)
                ], 8, _hoisted_13))
              }), 128))
            ])
          ]),
          (props.type === '1')
            ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                _hoisted_16,
                _createVNode(_component_van_radio_group, {
                  modelValue: scType.value,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((scType).value = $event)),
                  direction: "horizontal"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_van_radio, {
                      name: "2",
                      "icon-size": "16px",
                      "checked-color": "#ee0a24"
                    }, {
                      default: _withCtx(() => [
                        _hoisted_17
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_van_radio, {
                      name: "3",
                      "icon-size": "16px",
                      "checked-color": "#ee0a24"
                    }, {
                      default: _withCtx(() => [
                        _hoisted_18
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]))
            : _createCommentVNode("", true)
        ]),
        _createVNode(BookList, {
          "onUpdate:confirm": _cache[5] || (_cache[5] = ($event: any) => {
          bookInfo.value = $event;
          showBook.value = false;
        }),
          show: showBook.value
        }, null, 8, ["show"])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})